import { Component, Input, Output, EventEmitter, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-metwise-alerts-playbar',
  templateUrl: './metwise-alerts-playbar.component.html',
  styleUrls: ['./metwise-alerts-playbar.component.scss']
})
export class MetwiseAlertsPlaybarComponent implements OnChanges, OnDestroy {
  @Input() labelStrings: any[] = [];
  @Input() activeGroupName: any;
  @Output() groupSelected = new EventEmitter<string>();

  activeIndex = 0;
  isPlaying = false;
  private playTimer: any = null;

  private readonly SPEEDS = [
    { label: '1x', ms: 3000 },
    // { label: '2x', ms: 700 },
    // { label: '4x', ms: 350 }
  ];
  private speedIndex = 0;

  get speedLabel(): string { return this.SPEEDS[this.speedIndex].label; }

  get activeLabel(): string {
    const block = this.labelStrings && this.labelStrings[this.activeIndex];
    if (!block) return '';
    return (block.label && block.label.label) || block.groupName || '';
  }

  // Percentage from left where the fill and dot should sit (0–100)
  get fillPercent(): number {
    if (!this.labelStrings || this.labelStrings.length <= 1) return 0;
    return (this.activeIndex / (this.labelStrings.length - 1)) * 100;
  }

  // left style for the dot: centers the 12px dot on the fill endpoint
  get dotLeftStyle(): string {
    return 'calc(' + this.fillPercent + '% - 6px)';
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.labelStrings) {
      const prev: any[] = changes.labelStrings.previousValue;
      const curr: any[] = changes.labelStrings.currentValue;
      if (curr && curr.length > 0) {
        const tabChanged = !prev || prev.length !== curr.length ||
          prev.some((l: any, i: number) => l.groupName !== curr[i].groupName);
        if (tabChanged) {
          // Genuinely new label set (tab switch or first load) — reset and emit first horizon
          this.stopPlay();
          this.syncIndex(this.activeGroupName);
          setTimeout(() => this.emitActive(), 0);
        } else if (changes.activeGroupName) {
          // Same label set but horizon changed externally (infobox pill click)
          // selectBlock() was NOT the source — sync the highlight to match
          this.syncIndex(this.activeGroupName);
        }
        // Same labels + no activeGroupName change = selectBlock() already set activeIndex; leave play running
      }
    } else if (changes.activeGroupName) {
      // activeGroupName changed without any labelStrings change
      this.syncIndex(this.activeGroupName);
    }
  }

  private syncIndex(groupName: string) {
    if (!groupName || !this.labelStrings || !this.labelStrings.length) return;
    const idx = this.labelStrings.findIndex(l => l.groupName === groupName);
    this.activeIndex = idx > -1 ? idx : 0;
  }

  private emitActive() {
    if (this.labelStrings && this.labelStrings[this.activeIndex]) {
      this.groupSelected.emit(this.labelStrings[this.activeIndex].groupName);
    }
  }

  selectBlock(index: number) {
    if (!this.labelStrings || index < 0 || index >= this.labelStrings.length) return;
    this.activeIndex = index;
    this.groupSelected.emit(this.labelStrings[index].groupName);
  }

  togglePlay() {
    if (this.isPlaying) { this.stopPlay(); } else { this.startPlay(); }
  }

  cycleSpeed() {
    this.speedIndex = (this.speedIndex + 1) % this.SPEEDS.length;
    if (this.isPlaying) {
      clearInterval(this.playTimer);
      this.playTimer = setInterval(() => {
        this.selectBlock((this.activeIndex + 1) % this.labelStrings.length);
      }, this.SPEEDS[this.speedIndex].ms);
    }
  }

  private startPlay() {
    if (!this.labelStrings || !this.labelStrings.length) return;
    this.isPlaying = true;
    this.playTimer = setInterval(() => {
      this.selectBlock((this.activeIndex + 1) % this.labelStrings.length);
    }, this.SPEEDS[this.speedIndex].ms);
  }

  private stopPlay() {
    this.isPlaying = false;
    if (this.playTimer) { clearInterval(this.playTimer); this.playTimer = null; }
  }

  ngOnDestroy() { this.stopPlay(); }
}
